(function () {
  'use strict';

  const SECTION_SELECTOR = '[id^="CustomAllProducts-"]';
  const DATA_COLLECTION_URL = 'data-collection-url';
  const DATA_NO_REFRESH = 'data-no-refresh-filtering';
  const CLIENT_PAGE_PARAM = 'cap_page';
  const CLIENT_PER_PAGE = 25;

  function getSectionRoot(el) {
    return el && el.closest(SECTION_SELECTOR);
  }

  function getSectionApiId(section) {
    var wrapper = section.parentElement;
    if (wrapper && wrapper.id && wrapper.id.indexOf('shopify-section-') === 0) {
      return wrapper.id.replace(/^shopify-section-/, '');
    }
    wrapper = section.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace(/^shopify-section-/, '') : 'custom_all_products';
  }

  function hasAnyFilter(params) {
    var found = false;
    if (params.forEach) {
      params.forEach(function (value, key) {
        if (String(key).indexOf('filter.') === 0 || key === 'sort_by' || key === 'cap_category') found = true;
      });
    }
    return found;
  }

  function paramsWithoutClientPage(search) {
    var params = new URLSearchParams(search || '');
    params.delete(CLIENT_PAGE_PARAM);
    return params.toString();
  }

  function parseClientPage() {
    var params = new URLSearchParams(window.location.search || '');
    var raw = params.get(CLIENT_PAGE_PARAM);
    var n = parseInt(raw || '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function setClientPage(pageNum, pushState) {
    if (!window.history || !window.history.pushState) return;
    var params = new URLSearchParams(window.location.search || '');
    if (pageNum > 1) params.set(CLIENT_PAGE_PARAM, String(pageNum));
    else params.delete(CLIENT_PAGE_PARAM);
    var qs = params.toString();
    var nextUrl = window.location.pathname + (qs ? ('?' + qs) : '');
    if (pushState) window.history.pushState({ capUrl: nextUrl }, '', nextUrl);
    else window.history.replaceState({ capUrl: nextUrl }, '', nextUrl);
  }

  function hrefForClientPage(pageNum) {
    var params = new URLSearchParams(window.location.search || '');
    if (pageNum > 1) params.set(CLIENT_PAGE_PARAM, String(pageNum));
    else params.delete(CLIENT_PAGE_PARAM);
    var qs = params.toString();
    return window.location.pathname + (qs ? ('?' + qs) : '');
  }

  function buildParamsFromForm(form) {
    var params = new URLSearchParams();
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      if (value !== '') params.set(key, value);
    });
    return params;
  }

  function showLoading(section, show) {
    if (section) section.classList.toggle('cap-loading', !!show);
  }

  function replaceSectionWithHtml(section, html) {
    var wrapper = section.parentElement && section.parentElement.id && section.parentElement.id.indexOf('shopify-section-') === 0
      ? section.parentElement
      : section.closest('[id^="shopify-section-"]');
    if (!wrapper || !html) return null;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var newWrapper = temp.firstElementChild;
    if (!newWrapper) return null;
    wrapper.parentNode.replaceChild(newWrapper, wrapper);
    return newWrapper.querySelector(SECTION_SELECTOR);
  }

  function extractSectionHtmlFromPage(htmlString) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlString, 'text/html');
      var sectionEl = doc.querySelector(SECTION_SELECTOR);
      if (!sectionEl) return null;
      var wrapper = sectionEl.parentElement && sectionEl.parentElement.id && sectionEl.parentElement.id.indexOf('shopify-section-') === 0
        ? sectionEl.parentElement
        : null;
      if (!wrapper) {
        var list = doc.querySelectorAll('[id^="shopify-section-"]');
        for (var i = 0; i < list.length; i++) {
          if (list[i].querySelector(SECTION_SELECTOR)) {
            wrapper = list[i];
            break;
          }
        }
      }
      return wrapper ? wrapper.outerHTML : null;
    } catch (e) {
      return null;
    }
  }

  function navigateToUrl(section, newUrl, pushState) {
    if (!section || !section.getAttribute(DATA_NO_REFRESH)) {
      if (newUrl) window.location.href = newUrl;
      return Promise.resolve();
    }

    var fullFetchUrl = (newUrl.indexOf('http') === 0) ? newUrl : (window.location.origin + newUrl);

    showLoading(section, true);

    return fetch(fullFetchUrl, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        showLoading(section, false);
        var sectionHtml = extractSectionHtmlFromPage(text);
        if (!sectionHtml) {
          window.location.href = newUrl;
          return;
        }
        var newSection = replaceSectionWithHtml(section, sectionHtml);
        if (pushState !== false && window.history && window.history.pushState) {
          window.history.pushState({ capUrl: newUrl }, '', newUrl);
        }
        if (newSection) {
          initBrandTiles(newSection);
          initFilterForm(newSection);
          initClearFilters(newSection);
          initAjaxAddToCart(newSection);
          syncPriceSliderFromUrl(newSection);
          syncIntensityFromUrl(newSection);
          mergeAllCapProductPages(newSection);
        }
      })
      .catch(function () {
        showLoading(section, false);
        window.location.href = newUrl;
      });
  }

  function syncPriceSliderFromUrl(section) {
    var params = new URLSearchParams(window.location.search);
    var lte = params.get('filter.v.price.lte');
    var slider = section.querySelector('[data-price-slider]');
    var valueEl = section.querySelector('[data-price-slider-value]');
    var lteInput = section.querySelector('input[name="filter.v.price.lte"]');
    var wrap = section.querySelector('.cap-price-slider-wrap');
    if (!slider || !valueEl || !lteInput) return;
    var max = parseInt(slider.getAttribute('max'), 10) || 100;
    var val = lte ? parseInt(lte, 10) : max;
    if (val > max) val = max;
    if (val <= 0) val = max;
    slider.value = val;
    lteInput.value = val < max ? String(val) : '';
    valueEl.textContent = val >= max ? 'до ' + max + ' €' : 'до ' + val + ' €';
    if (wrap) wrap.style.setProperty('--slider-fill-percent', (val / max * 100) + '%');
  }

  function syncVendorFromUrl(section) {
    var vendorSelect = section.querySelector('[data-vendor-select]');
    if (!vendorSelect) return;
    var params = new URLSearchParams(window.location.search);
    var v = params.get('filter.p.vendor');
    vendorSelect.value = v != null && v !== '' ? v : '';
  }

  function syncCompatibilityFromUrl(section) {
    var compatibilitySelect = section.querySelector('[data-compatibility-select]');
    if (!compatibilitySelect) return;
    var params = new URLSearchParams(window.location.search);
    var c = params.get('filter.p.m.custom.compatibility');
    compatibilitySelect.value = c != null && c !== '' ? c : '';
  }

  function getCompatibilityDefaultLabel(section) {
    var compatibilitySelect = section.querySelector('[data-compatibility-select]');
    if (compatibilitySelect && compatibilitySelect.dataset.defaultLabel) {
      return compatibilitySelect.dataset.defaultLabel;
    }
    var labelEl = section.querySelector('.cap-filter-group--compatibility .cap-dropdown-label');
    return labelEl ? labelEl.textContent.trim() : 'Съвместимост';
  }

  function syncCategoryFromUrl(section) {
    var categorySelect = section.querySelector('[data-category-select]');
    if (!categorySelect) return;
    var params = new URLSearchParams(window.location.search);
    var c = params.get('cap_category');
    categorySelect.value = c != null && c !== '' ? c : '';
  }

  function syncSortFromUrl(section) {
    var sortSelect = section.querySelector('[data-sort-select]');
    if (!sortSelect) return;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort_by');
    if (sort === 'price-ascending' || sort === 'price-descending') {
      sortSelect.value = sort;
    } else {
      sortSelect.value = '';
    }
  }

  function syncIntensityFromUrl(section) {
    var params = new URLSearchParams(window.location.search);
    var val = params.get('filter.p.m.custom.intensity');
    var radios = section.querySelectorAll('.cap-intensity-radio');
    radios.forEach(function (r) {
      r.checked = (r.value === (val || ''));
    });
  }

  function getCardCompatValues(card) {
    var raw = card ? (card.getAttribute('data-cap-compatibility') || '') : '';
    if (!raw) return [];
    return raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function cardMatchesClientFilters(section, wrapper) {
    var card = wrapper.querySelector('.cap-card');
    if (!card) return true;

    var checked = section.querySelector('.cap-intensity-radio:checked');
    var intensityFilter = checked ? (checked.value || '') : '';
    if (intensityFilter !== '') {
      var cardIntensity = card.getAttribute('data-cap-intensity') || '';
      if (cardIntensity !== intensityFilter) return false;
    }

    var compatSelect = section.querySelector('[data-compatibility-select]');
    var compatFilter = compatSelect ? (compatSelect.value || '') : '';
    if (compatFilter !== '') {
      var compatValues = getCardCompatValues(card);
      if (compatValues.indexOf(compatFilter) === -1) return false;
    }

    var categorySelect = section.querySelector('[data-category-select]');
    var categoryFilter = categorySelect ? (categorySelect.value || '') : '';
    if (categoryFilter !== '') {
      var cardCategory = card.getAttribute('data-cap-category') || '';
      if (cardCategory !== categoryFilter) return false;
    }

    return true;
  }

  /**
   * Client-side product filters (intensity + compatibility).
   * Works even when Shopify storefront metafield filtering is not applied.
   */
  function syncCompatibilityOptionsFromCards(section) {
    var select = section.querySelector('[data-compatibility-select]');
    if (!select) return;
    var dropdown = select.closest('[data-custom-dropdown]');
    var panel = dropdown ? dropdown.querySelector('[data-dropdown-panel]') : null;
    if (!panel) return;
    var defaultLabel = getCompatibilityDefaultLabel(section);

    var valueSet = {};
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.value) valueSet[opt.value] = opt.textContent.trim();
    });

    var grid = section.querySelector('[data-product-grid]');
    if (grid) {
      grid.querySelectorAll('.cap-card[data-cap-compatibility]').forEach(function (card) {
        getCardCompatValues(card).forEach(function (val) {
          if (val) valueSet[val] = val;
        });
      });
    }

    var values = Object.keys(valueSet).sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: 'base' });
    });

    var currentValue = select.value;

    while (select.options.length > 1) {
      select.remove(1);
    }
    values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = valueSet[val];
      opt.selected = val === currentValue;
      select.appendChild(opt);
    });

    var emptyOption = panel.querySelector('.cap-dropdown-option[data-value=""]');
    panel.innerHTML = '';
    if (emptyOption) {
      panel.appendChild(emptyOption);
    } else {
      var emptyDiv = document.createElement('div');
      emptyDiv.className = 'cap-dropdown-option' + (currentValue === '' ? ' is-selected' : '');
      emptyDiv.setAttribute('data-value', '');
      emptyDiv.setAttribute('role', 'option');
      emptyDiv.textContent = defaultLabel;
      panel.appendChild(emptyDiv);
    }

    values.forEach(function (val) {
      var div = document.createElement('div');
      div.className = 'cap-dropdown-option' + (val === currentValue ? ' is-selected' : '');
      div.setAttribute('data-value', val);
      div.setAttribute('role', 'option');
      div.textContent = valueSet[val];
      panel.appendChild(div);
    });

    var triggerText = dropdown.querySelector('[data-dropdown-trigger-text]');
    if (triggerText) {
      triggerText.textContent = currentValue ? (valueSet[currentValue] || currentValue) : defaultLabel;
    }
  }

  function applyClientFilterChange(section, form) {
    var collectionUrl = section.getAttribute(DATA_COLLECTION_URL) || window.location.pathname;
    var params = buildParamsFromForm(form);
    params.delete(CLIENT_PAGE_PARAM);
    var q = params.toString();
    var url = collectionUrl + (q ? '?' + q : '');
    if (window.history && window.history.pushState) {
      window.history.pushState({ capUrl: url }, '', url);
    }
    applyClientProductFilters(section);
  }

  function applyClientProductFilters(section) {
    var grid = section.querySelector('.cap-product-grid');
    var noResultsEl = section.querySelector('[data-cap-filter-no-results]');
    if (!grid) return;

    var wrappers = grid.querySelectorAll('.cap-card-wrapper');
    var visibleCount = 0;

    wrappers.forEach(function (wrapper) {
      var show = cardMatchesClientFilters(section, wrapper);
      wrapper.dataset.capFilterMatch = show ? '1' : '0';
      if (show) visibleCount++;
    });

    if (noResultsEl) {
      noResultsEl.hidden = visibleCount > 0;
    }
    applyClientPagination(section, false);
  }

  function getStickyHeaderOffset() {
    var headerSection = document.querySelector('.shopify-section-header');
    if (!headerSection) return 0;
    var header = headerSection.querySelector('.header') || headerSection;
    return header.offsetHeight || 0;
  }

  function scrollToCollectionTop(section) {
    var target =
      section.querySelector('.cap-brand-grid') ||
      section.querySelector('.cap-filter-bar') ||
      section.querySelector('[data-product-grid]');
    if (!target) return;
    var offset = getStickyHeaderOffset() + 16;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function paginationParts(totalPages, page) {
    if (totalPages <= 1) return [];
    var parts = [];
    if (totalPages <= 7) {
      for (var i = 1; i <= totalPages; i++) parts.push({ kind: 'page', n: i });
      return parts;
    }
    var edge = [1, totalPages, page, page - 1, page + 1];
    var unique = {};
    var nums = [];
    edge.forEach(function (n) {
      if (n >= 1 && n <= totalPages && !unique[n]) {
        unique[n] = true;
        nums.push(n);
      }
    });
    nums.sort(function (a, b) { return a - b; });
    var prev = 0;
    nums.forEach(function (n) {
      if (n - prev > 1) parts.push({ kind: 'ellipsis' });
      parts.push({ kind: 'page', n: n });
      prev = n;
    });
    return parts;
  }

  function renderClientPagination(section, totalPages, currentPage) {
    var root = section.querySelector('[data-cap-pagination-root]');
    if (!root) return;
    root.innerHTML = '';
    root.hidden = true;
    var existingServerNav = section.querySelector('.cap-pagination');
    var existingServerInfo = section.querySelector('.cap-pagination__info');
    if (existingServerNav) existingServerNav.style.display = 'none';
    if (existingServerInfo) existingServerInfo.style.display = 'none';
    if (totalPages <= 1) return;

    var parts = paginationParts(totalPages, currentPage);
    var nav = document.createElement('nav');
    nav.className = 'cap-pagination';
    nav.setAttribute('aria-label', 'Навигация по страници');

    if (currentPage > 1) {
      var prev = document.createElement('a');
      prev.href = hrefForClientPage(currentPage - 1);
      prev.className = 'cap-pagination__link cap-pagination__nav';
      prev.setAttribute('aria-label', 'Предишна страница');
      prev.textContent = '‹ Предишна';
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        applyClientPagination(section, true, currentPage - 1);
      });
      nav.appendChild(prev);
    }

    var ul = document.createElement('ul');
    ul.className = 'cap-pagination__pages list-unstyled';
    ul.setAttribute('role', 'list');

    parts.forEach(function (part) {
      var li = document.createElement('li');
      if (part.kind === 'ellipsis') {
        var ell = document.createElement('span');
        ell.className = 'cap-pagination__ellipsis';
        ell.textContent = '…';
        li.appendChild(ell);
      } else if (part.n === currentPage) {
        var span = document.createElement('span');
        span.className = 'cap-pagination__page cap-pagination__page--current';
        span.setAttribute('aria-current', 'page');
        span.textContent = String(part.n);
        li.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.href = hrefForClientPage(part.n);
        a.className = 'cap-pagination__link cap-pagination__page';
        a.setAttribute('aria-label', 'Страница ' + part.n);
        a.textContent = String(part.n);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          applyClientPagination(section, true, part.n);
        });
        li.appendChild(a);
      }
      ul.appendChild(li);
    });
    nav.appendChild(ul);

    if (currentPage < totalPages) {
      var next = document.createElement('a');
      next.href = hrefForClientPage(currentPage + 1);
      next.className = 'cap-pagination__link cap-pagination__nav';
      next.setAttribute('aria-label', 'Следваща страница');
      next.textContent = 'Следваща ›';
      next.addEventListener('click', function (e) {
        e.preventDefault();
        applyClientPagination(section, true, currentPage + 1);
      });
      nav.appendChild(next);
    }

    var info = document.createElement('p');
    info.className = 'cap-pagination__info';
    info.textContent = 'Страница ' + currentPage + ' от ' + totalPages;

    root.appendChild(nav);
    root.appendChild(info);
    root.hidden = false;
  }

  function applyClientPagination(section, pushState, forcedPage) {
    var grid = section.querySelector('[data-product-grid]');
    if (!grid) return;
    var wrappers = Array.prototype.slice.call(grid.querySelectorAll('.cap-card-wrapper'));
    var filtered = wrappers.filter(function (wrapper) {
      return wrapper.dataset.capFilterMatch !== '0';
    });
    var totalPages = Math.max(1, Math.ceil(filtered.length / CLIENT_PER_PAGE));
    var currentPage = forcedPage || parseClientPage();
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;
    if (pushState === true) {
      setClientPage(currentPage, true);
    } else {
      setClientPage(currentPage, false);
    }

    var start = (currentPage - 1) * CLIENT_PER_PAGE;
    var end = start + CLIENT_PER_PAGE;
    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.capFilterMatch === '0') {
        wrapper.style.display = 'none';
        return;
      }
      var idx = filtered.indexOf(wrapper);
      wrapper.style.display = (idx >= start && idx < end) ? '' : 'none';
    });

    renderClientPagination(section, totalPages, currentPage);
    if (pushState === true) scrollToCollectionTop(section);
  }

  function initBrandTiles(section) {
    var grid = section.querySelector('[data-brand-grid]');
    if (!grid || grid.classList.contains('cap-brand-grid--system')) return;

    var collectionUrl = section.getAttribute(DATA_COLLECTION_URL) || window.location.pathname;
    var tiles = grid.querySelectorAll('[data-brand-tile]');

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var query = tile.getAttribute('data-filter-query');
        if (!query) return;
        var eq = query.split('=');
        var param = eq[0];
        var value = eq[1];
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.delete(CLIENT_PAGE_PARAM);
        var currentValue = currentParams.get(param);
        var isActive = tile.classList.contains('cap-brand-tile--active');

        var newUrl;
        if (isActive && currentValue === value) {
          currentParams.delete(param);
          newUrl = collectionUrl + (currentParams.toString() ? '?' + currentParams.toString() : '');
        } else {
          currentParams.set(param, value);
          newUrl = collectionUrl + '?' + currentParams.toString();
        }

        navigateToUrl(section, newUrl);
      }, true);
    });
  }

  function initCustomDropdowns(section) {
    var dropdowns = section.querySelectorAll('[data-custom-dropdown]');
    dropdowns.forEach(function (wrapper) {
      var select = wrapper.querySelector('.cap-dropdown-native');
      var trigger = wrapper.querySelector('[data-dropdown-trigger]');
      var triggerText = wrapper.querySelector('[data-dropdown-trigger-text]');
      var panel = wrapper.querySelector('[data-dropdown-panel]');
      var options = wrapper.querySelectorAll('.cap-dropdown-option');
      if (!select || !trigger || !triggerText || !panel || !options.length) return;

      function setTriggerText(text) {
        triggerText.textContent = text || '';
      }

      function updateSelectedState() {
        var val = select.value;
        panel.querySelectorAll('.cap-dropdown-option').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.getAttribute('data-value') === val);
        });
        var panelOptions = panel.querySelectorAll('.cap-dropdown-option');
        var selectedOpt = Array.prototype.find.call(panelOptions, function (o) { return o.getAttribute('data-value') === val; });
        setTriggerText(selectedOpt ? selectedOpt.textContent.trim() : val);
      }

      function close() {
        wrapper.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      }

      function open() {
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }

      function toggle() {
        if (wrapper.classList.contains('is-open')) close(); else open();
      }

      updateSelectedState();

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });

      panel.addEventListener('click', function (e) {
        var opt = e.target.closest('.cap-dropdown-option');
        if (!opt || !panel.contains(opt)) return;
        e.preventDefault();
        var val = opt.getAttribute('data-value');
        select.value = val || '';
        updateSelectedState();
        close();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      select.addEventListener('change', updateSelectedState);
    });

    if (!window._capDropdownOutsideBound) {
      window._capDropdownOutsideBound = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-custom-dropdown]')) return;
        document.querySelectorAll('[data-custom-dropdown].is-open').forEach(function (w) {
          w.classList.remove('is-open');
          var t = w.querySelector('[data-dropdown-trigger]');
          var p = w.querySelector('[data-dropdown-panel]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.setAttribute('hidden', '');
        });
      });
    }
  }

  function initFilterForm(section) {
    var form = section.querySelector('[data-filter-form]');
    if (!form) return;

    syncVendorFromUrl(section);
    syncCompatibilityFromUrl(section);
    syncCategoryFromUrl(section);
    syncSortFromUrl(section);

    var collectionUrl = section.getAttribute(DATA_COLLECTION_URL) || window.location.pathname;
    var priceSlider = section.querySelector('[data-price-slider]');
    var priceValueEl = section.querySelector('[data-price-slider-value]');
    var lteInput = section.querySelector('input[name="filter.v.price.lte"]');
    var sliderWrap = section.querySelector('.cap-price-slider-wrap');

    if (priceSlider && priceValueEl && lteInput) {
      syncPriceSliderFromUrl(section);
      function updateSliderUI() {
        var max = parseInt(priceSlider.getAttribute('max'), 10) || 100;
        var val = parseInt(priceSlider.value, 10);
        lteInput.value = val < max ? String(val) : '';
        priceValueEl.textContent = val >= max ? 'до ' + max + ' €' : 'до ' + val + ' €';
        if (sliderWrap) sliderWrap.style.setProperty('--slider-fill-percent', (val / max * 100) + '%');
      }
      priceSlider.addEventListener('input', updateSliderUI);
      priceSlider.addEventListener('change', function () { applyFilters(); });
    }

    function applyFilters() {
      var params = buildParamsFromForm(form);
      params.delete(CLIENT_PAGE_PARAM);
      var q = params.toString();
      var url = collectionUrl + (q ? '?' + q : '');
      navigateToUrl(section, url);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyFilters();
      return false;
    });

    var vendorSelect = section.querySelector('[data-vendor-select]');
    if (vendorSelect) {
      vendorSelect.addEventListener('change', function () { applyFilters(); });
    }
    var compatibilitySelect = section.querySelector('[data-compatibility-select]');
    if (compatibilitySelect) {
      compatibilitySelect.addEventListener('change', function () {
        applyClientFilterChange(section, form);
      });
    }
    var categorySelect = section.querySelector('[data-category-select]');
    if (categorySelect) {
      categorySelect.addEventListener('change', function () {
        applyClientFilterChange(section, form);
      });
    }
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () { applyFilters(); });
    }

    var intensityInputs = section.querySelectorAll('.cap-intensity-radio');
    intensityInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applyClientFilterChange(section, form);
      });
    });

    initCustomDropdowns(section);
    syncCompatibilityOptionsFromCards(section);
    applyClientProductFilters(section);
  }

  function initClearFilters(section) {
    var collectionUrl = section.getAttribute(DATA_COLLECTION_URL) || window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var showClear = hasAnyFilter(params);

    var clearBtns = section.querySelectorAll('[data-clear-filters]');
    clearBtns.forEach(function (btn) {
      btn.style.display = showClear ? '' : 'none';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        navigateToUrl(section, collectionUrl);
      });
    });

    var clearLinks = section.querySelectorAll('.cap-empty-state a[href]');
    clearLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        navigateToUrl(section, collectionUrl);
      });
    });
  }

  function initAjaxAddToCart(section) {
    var forms = section.querySelectorAll('[data-ajax-add-to-cart-form="true"]');
    var toastEl = section.querySelector('.cap-toast');

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (form.dataset.ajaxAddToCartForm !== 'true') return;
        e.preventDefault();

        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
        }

        var formData = new FormData(form);
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }
        var config = { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } };
        if (typeof window.fetch === 'undefined') {
          form.submit();
          return;
        }

        fetch((typeof window.routes !== 'undefined' && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add', config)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              if (toastEl) {
                toastEl.textContent = data.description || 'Error adding to cart';
                toastEl.hidden = false;
                setTimeout(function () { toastEl.hidden = true; }, 4000);
              }
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-disabled');
              }
              return;
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
            }
            if (typeof document.dispatchEvent === 'function') {
              document.dispatchEvent(new CustomEvent('cart:change'));
            }
            if (cartDrawer && data.sections) {
              cartDrawer.renderContents(data);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (toastEl) {
              var productTitle = form.closest('.cap-card') && form.closest('.cap-card').querySelector('.cap-card__title-link');
              var name = productTitle ? productTitle.textContent.trim() : 'Product';
              toastEl.textContent = name + ' добавен в количката!';
              toastEl.hidden = false;
              setTimeout(function () { toastEl.hidden = true; }, 3000);
            }
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
            }
            if (toastEl) {
              toastEl.textContent = 'Error adding to cart';
              toastEl.hidden = false;
              setTimeout(function () { toastEl.hidden = true; }, 4000);
            }
          });
      });
    });
  }

  function pickCapHtmlFromSections(sections, sectionFile) {
    if (!sections || typeof sections !== 'object') return '';
    var fileU = sectionFile.replace(/-/g, '_');
    if (sections[sectionFile]) return sections[sectionFile];
    if (sections[fileU]) return sections[fileU];
    var keys = Object.keys(sections);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (/custom[-_]all[-_]products/i.test(k)) return sections[k];
    }
    for (var j = 0; j < keys.length; j++) {
      var v = sections[keys[j]];
      if (typeof v === 'string' && v.indexOf('cap-product-grid') !== -1 && v.indexOf('cap-card-wrapper') !== -1) {
        return v;
      }
    }
    return '';
  }

  function appendCapCardsFromHtml(htmlString, grid) {
    if (!htmlString || !grid) return;
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    var remoteSection = doc.querySelector(SECTION_SELECTOR);
    if (!remoteSection) return;
    var remoteGrid = remoteSection.querySelector('[data-product-grid]');
    if (!remoteGrid) return;
    for (var c = 0; c < remoteGrid.children.length; c++) {
      var li = remoteGrid.children[c];
      if (!li.classList || !li.classList.contains('cap-card-wrapper')) continue;
      grid.appendChild(document.importNode(li, true));
    }
  }

  function mergeAllCapProductPages(section) {
    if (section.dataset.capMergedPages === '1') {
      syncCompatibilityOptionsFromCards(section);
      applyClientProductFilters(section);
      return Promise.resolve();
    }
    var resultsArea = section.querySelector('[data-cap-results-area]');
    if (!resultsArea) return Promise.resolve();
    var totalPages = parseInt(resultsArea.getAttribute('data-cap-shopify-pages') || '1', 10);
    if (totalPages < 2) {
      section.dataset.capMergedPages = '1';
      syncCompatibilityOptionsFromCards(section);
      applyClientProductFilters(section);
      return Promise.resolve();
    }

    var sectionFile = section.getAttribute('data-cap-section-file') || 'custom-all-products';
    var grid = section.querySelector('[data-product-grid]');
    if (!grid) return Promise.resolve();

    var basePath = window.location.pathname;
    var sectionDomId = section.id;
    showLoading(section, true);

    function fetchPage(pageNum) {
      var params = new URLSearchParams(window.location.search || '');
      params.delete(CLIENT_PAGE_PARAM);
      params.set('sections', sectionFile);
      params.set('page', String(pageNum));
      var urlJson = basePath + '?' + params.toString();
      return fetch(urlJson, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) return '';
          return res.text();
        })
        .then(function (bodyText) {
          var html = '';
          if (bodyText) {
            try {
              var data = JSON.parse(bodyText);
              html = pickCapHtmlFromSections(data.sections, sectionFile);
            } catch (e) {
              /* not JSON */
            }
          }
          if (html) {
            appendCapCardsFromHtml(html, grid);
            return;
          }
          var params2 = new URLSearchParams(window.location.search || '');
          params2.delete(CLIENT_PAGE_PARAM);
          params2.delete('sections');
          params2.delete('section_id');
          params2.set('page', String(pageNum));
          var urlDoc = basePath + '?' + params2.toString();
          return fetch(urlDoc, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
          }).then(function (res2) {
            if (!res2.ok) return;
            return res2.text();
          }).then(function (docHtml) {
            if (!docHtml) return;
            var doc = new DOMParser().parseFromString(docHtml, 'text/html');
            var inner = sectionDomId ? doc.getElementById(sectionDomId) : null;
            var htmlStr = '';
            if (inner) htmlStr = inner.outerHTML;
            else {
              var sec = doc.querySelector(SECTION_SELECTOR);
              if (sec) htmlStr = sec.outerHTML;
            }
            appendCapCardsFromHtml(htmlStr, grid);
          });
        });
    }

    var chain = Promise.resolve();
    for (var p = 2; p <= totalPages; p++) {
      (function (pageNum) {
        chain = chain.then(function () {
          return fetchPage(pageNum);
        });
      })(p);
    }

    return chain
      .then(function () {
        section.dataset.capMergedPages = '1';
        initAjaxAddToCart(section);
        initClearFilters(section);
        syncCompatibilityOptionsFromCards(section);
        applyClientProductFilters(section);
      })
      .catch(function () { /* keep partial grid */ })
      .then(function () {
        showLoading(section, false);
      });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      if (!section.getAttribute(DATA_NO_REFRESH)) return;
      initBrandTiles(section);
      initFilterForm(section);
      initClearFilters(section);
      initAjaxAddToCart(section);
      syncIntensityFromUrl(section);
      mergeAllCapProductPages(section);
    });
  }

  function initPopstate() {
    var lastNoClientPageQuery = paramsWithoutClientPage(window.location.search || '');
    window.addEventListener('popstate', function (e) {
      var section = document.querySelector(SECTION_SELECTOR + '[' + DATA_NO_REFRESH + ']');
      if (!section) return;
      var nowNoClientPageQuery = paramsWithoutClientPage(window.location.search || '');
      if (nowNoClientPageQuery === lastNoClientPageQuery) {
        applyClientPagination(section, false);
        return;
      }
      lastNoClientPageQuery = nowNoClientPageQuery;
      var url = window.location.pathname + (window.location.search || '');
      navigateToUrl(section, url, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initPopstate();
    });
  } else {
    init();
    initPopstate();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector(SECTION_SELECTOR) || (getSectionRoot(e.target) && e.target);
      if (section && section.getAttribute(DATA_NO_REFRESH)) {
        initBrandTiles(section);
        initFilterForm(section);
        initClearFilters(section);
        initAjaxAddToCart(section);
        syncIntensityFromUrl(section);
        mergeAllCapProductPages(section);
      }
    });
  }
})();
